<div class="townip-top-menu-wrapper">
  <ul class="top-menu">
    <li class="toggler">
      <i class="fa toggle-icon fa-chevron-right" [ngClass]="expanded ? 'rotated' : 'no-rotate'" (click)="toggleNavbar()"></i>
    </li>
    <li class="search" *ngIf="isAdminPM || isSalesAccountManager">
      <townip-search-system></townip-search-system>
    </li>
    <li class="server-banner" *ngIf="isTestServer">
      <townip-server-banner></townip-server-banner>
    </li>
    <li class="res-user-nav" *ngIf="user">
      <townip-initials
        data-toggle="dropdown"
        data-display="static"
        fontSize="1rem"
        [size]="40"
        [data]="user.firstName + ' ' + user.lastName">
      </townip-initials>
      <ng-container *ngTemplateOutlet="navDropdown"></ng-container>
    </li>
    <li class="user-nav" *ngIf="user">
      <button
        data-toggle="dropdown"
        data-display="static"
        class="btn profile-toggle d-flex align-items-center">
        <townip-initials fontSize="1rem" [size]="40" [data]="user.firstName + ' ' + user.lastName"></townip-initials>
        <span class="ml-2">{{user | displayShortName:30}}</span>
      </button>
      <ng-container *ngTemplateOutlet="navDropdown"></ng-container>
    </li>

    <ng-container *ngIf="!isForecasterOnly">
      <li class="nav-divider" *ngIf="user"></li>
      <!-- Alerts bell and dropdown removed per Ops Summit decision -->
      <li class="right-nav ml-2 margin-top-20 mr-2" *ngIf="user">
        <div
          (click)="messagequickview.toggleMenu()"
          tabindex="0"
          (blur)="messagequickview.hideMenu()"
          [tooltip]="unreadMessageCount + ' Messages'"
          placement="bottom"
          containerClass="toolbar-tooltip">
          <i class="fa fa-envelope-o toolbar-icon">
            <span class="messages-nav" *ngIf="unreadMessageCount > 0">&nbsp;</span>
          </i>
        </div>
        <townip-message-quickview
          #messagequickview
          [user]="user"
          (unreadMessageCountChange)="updateMessageCount($event)">
        </townip-message-quickview>
      </li>
      <li class="nav-divider" *ngIf="user && (isCompanyUser || user?.userType === 'INTERNAL')"></li>
      <li *ngIf="user && isCompanyUser" class="new-actions-container">
        <ng-container *ngTemplateOutlet="newActions"></ng-container>
      </li>
      <li *ngIf="isEditableInternalUser" class="new-actions-container">
        <ng-container *ngTemplateOutlet="pmActions"></ng-container>
      </li>
    </ng-container>
  </ul>

  <ng-template #newActions>
    <button *townipIfUserHasTransFilingAccess type="button" label="New Project" pButton
            class="raised-button header-cta ui-button-success btn-action-new margin-left-5"
            [routerLink]="['/redirect']" [queryParams]="{route: '/estimate/new-estimate-2', query: projectQuery}">
    </button>
    <ng-container *ngIf="!userPermissions.RESTRICTED_COMPANY_USER">
      <button *townipIfUserHasTransFilingAccess
              type="button" label="New Estimate" pButton
              class="raised-button header-cta ui-button-success btn-action-new margin-left-5"
              [routerLink]="['/redirect']" [queryParams]="{route: '/estimate/new-estimate-2'}">
      </button>
    </ng-container>
  </ng-template>

  <ng-template #pmActions>
    <button type="button" label="New Client Project" pButton
            class="raised-button header-cta ui-button-success btn-action-new margin-right-5"
            (click)="newClientProject()">
    </button>
    <button type="button" label="New Client Estimate" pButton
            class="raised-button header-cta ui-button-success btn-action-new margin-left-5"
            (click)="newClientEstimate()">
    </button>
  </ng-template>

  <ng-template #navDropdown>
    <ul class="dropdown-menu right-nav-menu">
      <li *ngIf="user" class="nav-user-header d-flex align-items-center">
        <townip-initials fontSize="1.0rem" [size]="36" [data]="user.firstName + ' ' + user.lastName"></townip-initials>
        <div class="ml-2">
          <div class="prof-name">{{user.firstName}} {{user.lastName}}</div>
          <div class="prof-email">{{user.email}}</div>
        </div>
      </li>
      <li class="separator"></li>
      <!-- TODO profile/alerts/security navigation -->
      <li class="nav-item">
        <a class="dropdown-item" [routerLink]="profileRoute">My Profile</a>
      </li>
      <li class="nav-item collapsed-nav" *ngIf="!isForecasterOnly">
        <a class="dropdown-item" routerLink="/messages">Messages - {{unreadMessageCount}}</a>
      </li>
      <li class="separator"></li>
      <li class="nav-item">
        <a class="dropdown-item" routerLink="/auth/logout" [ngClass]="{ disabled: noLogout }">
          <i *ngIf="noLogout" class="fa fa-spin fa-circle-o-notch mr-1"></i>Log out
        </a>
      </li>
    </ul>
  </ng-template>
</div>
